import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [lookups, setLookups] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch (e) {
      try {
        const { data } = await api.post("/auth/refresh");
        setUser(data.user);
      } catch (e2) {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => {
    loadMe();
    const onLogout = () => setUser(false);
    window.addEventListener("roxy:logout", onLogout);
    return () => window.removeEventListener("roxy:logout", onLogout);
  }, [loadMe]);

  useEffect(() => {
    if (user) {
      api.get("/lookups").then((r) => setLookups(r.data)).catch(() => {});
    }
  }, [user]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  const can = (p) => !!user && user.permissions?.includes(p);

  return (
    <AuthCtx.Provider value={{ user, setUser, logout, can, lookups, setLookups, reload: loadMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
